import { axiosInstance } from "api/axios.instance"
import type { TDimensionsToleranceValues } from "types/configuration.type"

class DimensionsToleranceService {
	static BASE_URL = "/model-numbers"

	getTolerance() {
		return axiosInstance.get(`${DimensionsToleranceService.BASE_URL}/dimensions-tolerance/`)
	}

	updateTolerance(values: TDimensionsToleranceValues) {
		return axiosInstance.patch(`${DimensionsToleranceService.BASE_URL}/dimensions-tolerance/`, {
			width_tolerance: values.width,
			height_tolerance: values.height,
			depth_tolerance: values.depth,
		})
	}
}

export default new DimensionsToleranceService()
